import env from '@polleverywhere/core/lib/env'
import { platform } from '@polleverywhere/slideware-bindings'
import isMobileApp from './is_mobile_app'
import openWindow from './open_window'

function app (role) {
  if (role === 'presenter') {
    if (isMobileApp()) {
      return 'mobile_presenter'
    }

    switch (platform()) {
      case 'windows':
        return 'win_presenter'
      case 'mac':
        return 'mac_presenter'
      case 'google':
        return 'goog_presenter'
      default: break
    }
  }

  return role
}

function supportUrl (role) {
  return `${env.get('api_url')}contact/application_troubleshoot?app=${app(role)}`
}

export default async function openApplicationTroubleshoot (state) {
  await openWindow(supportUrl(state.get('role')), state)
}
